import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface FlowPlaceholderProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
}

export default function FlowPlaceholder({ title, subtitle, icon }: FlowPlaceholderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: 120,
        py: 4,
        px: 3,
        textAlign: 'center',
      }}
    >
      {icon && <Box sx={{ mb: 1 }}>{icon}</Box>}
      <Typography variant="body1" color="text.secondary">
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.disabled" sx={{ mt: 1, maxWidth: 360 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
